module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('loading-icon', {
    staticClass: "c-card c-card--target"
  }) : _c('section', {
    staticClass: "c-card c-card--target t-target"
  }, [_c('div', {
    staticClass: "c-card--target__infographic"
  }, [_c('div', {
    staticClass: "c-card--target__infographic__chart"
  }, [_c('svg', {
    staticClass: "c-card--target__infographic__chart__svg",
    attrs: {
      "viewBox": "-1 -1 2 2"
    }
  }, [_c('circle', {
    staticClass: "c-card--target__infographic__chart__spectrum t-target__spectrum",
    attrs: {
      "cx": "0",
      "cy": "0",
      "r": ".8"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "c-card--target__infographic__chart__progress t-target__progress",
    class: _vm.animateGauge,
    attrs: {
      "cx": "0",
      "cy": "0",
      "r": ".8"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-card--target__infographic__percentage"
  }, [_c('p', {
    staticClass: "c-card--target__infographic__percentage__number t-target__percentage"
  }, [_vm._v(_vm._s(_vm.percentage + '%'))])])]), _vm._v(" "), (_vm.targetAmount !== 0) ? _c('div', {
    staticClass: "c-card--target__details"
  }, [_c('h2', {
    staticClass: "c-card--target__details__title t-headline"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h3', {
    staticClass: "c-card--target__details__progress"
  }, [_c('div', {
    staticClass: "c-card--target__details__progress__numerator t-target__numerator",
    class: {
      'c-card--target__details__progress__numerator--currency': _vm.isCurrency
    }
  }, [(_vm.isCurrency) ? _c('span', [_vm._v("$")]) : _vm._e(), _c('vue-numeric', {
    attrs: {
      "separator": ",",
      "precision": 0,
      "read-only": true,
      "value": _vm.progressAmount
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "c-card--target__details__progress__denominator t-target__denominator"
  }, [_c('i', [_vm._v("of")]), _vm._v(" "), (_vm.isCurrency) ? _c('span', [_vm._v("$")]) : _vm._e(), _c('vue-numeric', {
    attrs: {
      "separator": ",",
      "precision": 0,
      "read-only": true,
      "value": _vm.targetAmount
    }
  })], 1)])]) : _c('div', {
    staticClass: "c-card--target__details"
  }, [_c('h2', {
    staticClass: "c-card--target__details__title t-headline"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h3', {
    staticClass: "c-card--target__details__progress"
  }, [_c('span', {
    staticClass: "c-card--target__details__progress__not-set t-target__numerator"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.card_target.target_not_set')) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a093616"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/cards/Target.vue
// module id = 553
// module chunks = 1